module.exports = __webpack_public_path__ + "static/img/03BG.61e202cd.jpg";